import { render, staticRenderFns } from "./index.vue?vue&type=template&id=0a6b4c1e&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=0a6b4c1e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a6b4c1e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/chuongdev/Desktop/project/333QLK_FE/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0a6b4c1e')) {
      api.createRecord('0a6b4c1e', component.options)
    } else {
      api.reload('0a6b4c1e', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=0a6b4c1e&scoped=true&", function () {
      api.rerender('0a6b4c1e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/report/inventory/index.vue"
export default component.exports